<script>import { okhsl } from "../../../d3-mapp/color/index.js";
import SignalPlot2 from "./SignalPlot2.svelte";
import { splineToTaggedPath } from "../../../dsp/signal/helpers/to-path.js";
import { locale } from "../../reports/global-store.js";
import {
  mapToHistogramData,
  mapToTagDefinitions,
  mapToTagMap
} from "./signal-plot-helpers.js";
import {
  timeRangeContextKey
} from "../time-plot-context.js";
import { getContext } from "svelte";
import {
  findIntersections,
  getProjectionData,
  getTaggedSectionsWhereSplineIsHighestLowest
} from "../../../dsp/signal/helpers/spline-intersections.js";
export let signals;
export let splineLabels;
export let title;
export let yAxisLabel;
export let colors = [okhsl("hsl(0,0%,0%,1.0)")];
export let undefinedColors = [okhsl("hsl(0,0%,30%,1.0)")];
export let scalarEther = true;
export let showAxis = true;
export let showThreshold = true;
export let showProjection = true;
export let showHistogram = true;
export let tags = void 0;
const { range } = getContext(timeRangeContextKey);
$:
  splines = signals.map(
    (signal) => signal.spline($range.start.getTime(), $range.end.getTime())
  );
let tagDefinitions = [];
let paths = [];
let graphStrokes;
let projectionStrokes;
let projectionData;
$: {
  tagDefinitions = mapToTagDefinitions(tags, $locale);
  graphStrokes = mapToTagMap(
    tagDefinitions,
    colors,
    undefinedColors,
    $locale
  );
  projectionStrokes = graphStrokes["highest"].stroke.reduce(
    (map, stroke, i) => {
      map[`_${i.toString()}`] = {
        tag: `_${i.toString()}`,
        label: splineLabels[i],
        index: i,
        stroke: [stroke]
      };
      return map;
    },
    {}
  );
}
$: {
  const intersections = findIntersections(splines);
  paths = splines.map((spline, i) => {
    const taggedSections = getTaggedSectionsWhereSplineIsHighestLowest(
      intersections,
      i,
      true,
      "highest"
    );
    return splineToTaggedPath(spline, taggedSections);
  });
  projectionData = [getProjectionData(intersections, true)];
}
$:
  histogramData = mapToHistogramData(projectionStrokes, projectionData[0]);
</script>

<SignalPlot2
  {title}
  label={yAxisLabel}
  labelSwatch={colors.length === 1 ? colors[0] : undefined}
  {tags}
  {scalarEther}
  {showAxis}
  {showThreshold}
  {showProjection}
  {showHistogram}
  {paths}
  {projectionData}
  {histogramData}
  {graphStrokes}
  {projectionStrokes}
/>
